import React, {useEffect, useMemo, useState} from 'react'
import {Container, Button, Row, Col, Card} from 'react-bootstrap'
import ReactTable from '../../components/ReactTable/ReactTable'
import {useTranslation} from 'react-i18next'
import Network from '../../enums/Network'
// import BasketDetail from './BasketDetail'
// import BasketHistoryDetail from './BasketHistoryDetail'
import DateUtil from '../../utils/DateUtil'
import BestBuyActions from '../../enums/BestBuyAction'
import {
  loadDbViewPortfolioPerCustomer,
  loadDbViewPortfolioTotal,
} from '../../services/api'

// import './BestBuyBasketList.css'

export default function BestBuyTotalReport(props) {
  const {t} = useTranslation()

  const initialStates = useMemo(
    () => ({
      coinsData: [],
      loading: true,
      sort_field: '-id'
      
    }),
    [],
  )

  const [state, setState] = useState(initialStates)

  const {
    coinsData,
    loading,
    sort_field
  } = state

  // const bestBuyBasketColumns = [
  //   {
  //     Header: t('common.id'),
  //     accessor: 'id',
  //     width: '2%',
  //     Footer: info => {
  //       const total = useMemo(() => info.rows.length)
  //       return (
  //         <>
  //           {t('table.countRows')} {count}
  //         </>
  //       )
  //     },
  //   },

  //   {
  //     Header: t('bestBuy.basket-price-usdt'),
  //     accessor: `basket_price.usdt`,
  //     Footer: info => {
  //       return (
  //         <div className="table-footer-cell">
  //           {t('table.allBasketPrice')} :{' '}
  //           {parseFloat(allBasketPrice).toFixed(2)}
  //         </div>
  //       )
  //     },
  //   },
  //   {
  //     Header: t('common.customer_name'),
  //     size: 4,
  //     accessor: d => `${d.customer_data.name} `,
  //   },
  //   {
  //     Header: t('common.create_datetime'),
  //     accessor: d => `${DateUtil.convertToJalaliBirthDate(d.created_on)}`,
  //   },
  //   {
  //     Header: t('bestBuy.last_update'),
  //     accessor: d => `${DateUtil.convertToJalaliBirthDate(d.last_update)}`,
  //   },
  //   {
  //     Header: t('common.actions'),
  //     accessor: 'actions',
  //     sortable: false,
  //     filterable: false,
  //   },
  // ]

  // const dataBestBuyBasketHandler = data => {
  //   const bestBuyBasket = data.map((prop, key) => {
  //     return {
  //       ...prop,
  //       actions: (
  //         <div className="actions-right">
  //           <Button
  //             onClick={() => {
  //               setState(prev => ({
  //                 ...prev,
  //                 selectedBestBuyBaskets: prop,
  //                 showDetail: true,
  //               }))
  //             }}
  //             variant="warning"
  //             size="sm"
  //             className="text-warning btn-link edit"
  //           >
  //             <i className="fa fa-list"></i>
  //           </Button>
  //           <Button
  //             onClick={() => {
  //               setState(prev => ({
  //                 ...prev,
  //                 selectedBestBuyBaskets: prop,
  //                 showDetailDialog: true,
  //               }))
  //             }}
  //             variant="info"
  //             size="sm"
  //             className="text-info btn-link like"
  //           >
  //             <i className="fa fa-eye" />
  //           </Button>
  //         </div>
  //       ),
  //     }
  //   })
  //   setState(prev => ({
  //     ...prev,
  //     bestBuyBasketsList: bestBuyBasket,
  //   }))
  // }

  const fetchData = () => {
      setState(prev => ({
        ...prev,
        loading: true,
      }))
      loadDbViewPortfolioTotal()
        .then(response => {
          console.log("my data: ", response.data)
          setState(prev => ({
            coinsData: response.data,
          }))
        })
        .catch(err => {
          alert('عملیات با خطا مواجه شد')
          alert(JSON.stringify(err))
          setState(prev => ({
            ...prev,
            loading: false,
          }))
        })
    }

  useEffect(() => {
    let timeout = null
    if (!timeout) {
      timeout = setTimeout(() => {
        fetchData(1, 10)
      }, 800)
    }

    return () => clearTimeout(timeout)
  }, [])

  const coinsColumns = [
    {
      Header: t('ارز'),
      accessor: 'coin',
      
    },
    {
      Header: t('مقدار'),
      accessor: d =>
        d.sum &&
        d.sum.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
    }
  ]


  return (
  <>
  <Container fluid>
        <Row>
          <Col md="12">
                <Card>
                  <Card.Body>
                    <Card.Header>مجموع موجودی</Card.Header>
                    <br />
                    <ReactTable
                      className="-striped -highlight primary-pagination"
                      data={coinsData}
                      columns={coinsColumns}
                      count={coinsData.length}
                      showPagination={false}
                    />
                  </Card.Body>
                </Card>
          </Col>
        </Row>
     </Container>
    </>


  )
 }
